import { ReactNode, useEffect, useRef } from 'react';

import { PUBLIC_CONTACT_US } from 'global/public-routes.constants';
import { PStyled, LinkStyled } from 'approot/shared/styles/typography.style';
import { MEDIA_SM, useMediaQuery } from 'approot/shared/style';
import { SecondaryButton } from 'approot/shared/styles/buttons/buttons';
import ImageContentInfo from 'approot/shared/images/content/image-content-info';
import * as Styled from './error-message-actionable.style';
import { Box } from 'approot/shared/design-system/box/box.style';

type Props = {
  title?: ReactNode;
  message?: ReactNode;
  action?: ReactNode;
  paddingTop?: number;
  ariaPage: string;
};

export const ErrorMessageActionable = ({
  title,
  message,
  action,
  paddingTop,
  ariaPage,
}: Props) => {
  const isMediaUpSmall = useMediaQuery(MEDIA_SM);

  const messageRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    messageRef.current?.focus();
  }, []);

  return (
    <Styled.ErrorContainer
      $paddingTop={paddingTop}
      ref={messageRef}
      tabIndex={-1}
      aria-label={`${ariaPage}, We’re having trouble loading this content at the moment`}
    >
      <ImageContentInfo width={120} />
      <Box $marginBottom={isMediaUpSmall ? 24 : 16}>
        <Styled.ErrorTitle
          aria-label={`${ariaPage}, ${title || 'Error loading content'}`}
        >
          {title ? title : `Don’t worry, it’s not you`}
        </Styled.ErrorTitle>
        {message ? (
          message
        ) : (
          <PStyled>
            We&rsquo;re having trouble loading this content at the moment. Try
            refreshing this page.
          </PStyled>
        )}
        <PStyled>
          If the problem persists{' '}
          <LinkStyled to={PUBLIC_CONTACT_US}>Contact Us</LinkStyled>
        </PStyled>
      </Box>
      {action ? (
        action
      ) : (
        <SecondaryButton type="button" onClick={() => window.location.reload()}>
          Refresh
        </SecondaryButton>
      )}
    </Styled.ErrorContainer>
  );
};
